import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0191',
    ecrans: ['00-2'],
    params: ['?tagcleint']
});
